import { Component, Input } from '@angular/core';
import { LinksService } from '../../links/links.service';

@Component({
    selector: 'aside-card',
    templateUrl: './aside-card.component.html',
    styleUrls: ['./aside-card.component.scss']
})
export class AsideCardComponent {

    @Input() mainCard: boolean = false;
    hotForSecurityLink = this.linksService.getBlogLink();

    constructor(
        public linksService: LinksService
    ) { }

}